import { useTranslation } from 'react-i18next'

import { CardContent, CardDashboard, Divider } from '@percent/lemonade'
import { ContactDetailsProps } from './ContactDetails.types'

export function ContactDetails({ contactDetails }: Readonly<ContactDetailsProps>) {
  const { t } = useTranslation()

  const formatName = (firstName?: string, lastName?: string) => {
    const name = [firstName, lastName].filter(Boolean).join(' ')

    return name || t('typography.notAvailable')
  }

  const getContactKey = (contact: ContactDetailsProps['contactDetails'][number], index: number) => {
    const keyParts = [contact.primaryEmail, contact.firstName, contact.lastName].filter(Boolean)

    return keyParts.length > 0 ? keyParts.join('-') : `contact-${index}`
  }

  if (!contactDetails || contactDetails.length === 0) {
    return (
      <CardDashboard title={t('typography.contactDetails')}>
        <CardContent testId="no-contact-details">{t('typography.notAvailable')}</CardContent>
      </CardDashboard>
    )
  }

  return (
    <CardDashboard title={t('typography.contactDetails')}>
      {contactDetails.map((contact, index) => (
        <div key={getContactKey(contact, index)}>
          <CardContent title={t('typography.name')} testId="verification-agent-name">
            {formatName(contact.firstName, contact.lastName)}
          </CardContent>
          <CardContent title={t('typography.email')} testId="verification-agent-email">
            {contact.primaryEmail || t('typography.notAvailable')}
          </CardContent>
          {index < contactDetails.length - 1 && <Divider my={16} data-testid="contact-details-divider" />}
        </div>
      ))}
    </CardDashboard>
  )
}
